"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = exports.Router = void 0;
var dynamicLoad_1 = require("../../dynamicLoad");
Object.defineProperty(exports, "Router", { enumerable: true, get: function () { return dynamicLoad_1.Router; } });
var routesCC_1 = require("./routesCC");
Object.defineProperty(exports, "Routes", { enumerable: true, get: function () { return routesCC_1.Routes; } });
//# sourceMappingURL=index.js.map